// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"e4edcae5","513":"84df3d46","787":"f31c0204"}[chunkId] + ".chunk.js";
};